import useInViewport from "hooks/useInViewport";
import useVideoSourceSize from "hooks/useVideoSourceSize";
import React, { useEffect, useRef, useState } from "react";
import assetPath from "utils/assetPath.utils";
//
import "./videoBlock.block.scss";

interface Props {
  id: string;
  video: {
    desktop: string;
    mobile: string;
  };
  poster: string;
  link?: string;
}

const VideoBlock: React.FC<Props> = (props) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const inViewport = useInViewport(videoRef);

  const videoSize = useVideoSourceSize();

  useEffect(() => {
    const video = videoRef.current;
    if (!!video && !!videoSize) {
      if (inViewport && video.paused) {
        const promise = video.play();
        promise.then().catch((error) => console.log("video play not possible"));
      } else if (!inViewport && !video.paused) {
        video.pause();
      }
    }
  }, [inViewport && videoSize]);

  return (
    <div className="video-block" id={props.id}>
      <div className="video-block__wrapper">
        <div className="video-block__inner">
          <video
            src={!!videoSize ? props.video[videoSize] : undefined}
            loop
            muted
            playsInline
            poster={assetPath(props.poster)}
            ref={videoRef}
          />
          {!!props.link && <a className="video-block__link" href={props.link} target="_blank" rel="norefferer" />}
        </div>
      </div>
    </div>
  );
};

export default VideoBlock;
